import * as Sentry from "@sentry/browser"
import { Integrations } from "@sentry/tracing"
import Vue from 'vue'

Sentry.init({
	dsn: process.env.SENTRY_DSN,
	beforeSend(event, hint) {
		/*
		if (event.exception) {
		  Sentry.showReportDialog({ eventId: event.event_id });
		}
		*/
		return event;
	},
	maxBreadcrumbs: 50,
	debug: process.env.APP_ENV !== 'production',
	release: process.env.APP_RELEASE,
	environment: process.env.APP_ENV,
	sampleRate: 1.0,
	integrations: [new Integrations.BrowserTracing()],
  	tracesSampleRate: 1.0,
	Vue,
  	tracingOptions: {
    	trackComponents: true,
  	},
});


Sentry.configureScope((scope) => {
	scope.setTag("side", "client");
});

console.log(process.env);



// WEBPACK FOOTER //
// ./resources/js/config/sentry.js